/**
 * @generated SignedSource<<9c1186a19770454e93f1dcdc82808c98>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TxnClassificationEnum = "CHARGEBACK" | "DIVIDEND" | "FINANCING_FEE" | "FRAUDULENT" | "LOAN_PROCEEDS" | "LOAN_REPAYMENT" | "PROCESSOR_FEE" | "REFUND" | "SALARY" | "TAX_PAYMENT" | "TAX_REFUND" | "%future added value";
export type loansPage_Query$variables = {
  perYear?: number | null | undefined;
};
export type loansPage_Query$data = {
  readonly loans: {
    readonly candidates: ReadonlyArray<{
      readonly flagged: boolean;
      readonly loan: {
        readonly id: string;
        readonly label: string;
      } | null | undefined;
      readonly rank: number;
      readonly row: {
        readonly accountNumber: string | null | undefined;
        readonly amount: number;
        readonly counterparty: {
          readonly name: string;
        } | null | undefined;
        readonly description: string;
        readonly md5: string;
        readonly postingDate: string;
        readonly txn: {
          readonly id: string;
        };
      };
      readonly year: number;
    }>;
    readonly debtByMonth: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly loans: ReadonlyArray<{
      readonly expectedMonthlySalesCents: number | null | undefined;
      readonly feeCents: number;
      readonly fullyRepaid: boolean;
      readonly handle: string;
      readonly holdbackBps: number;
      readonly id: string;
      readonly label: string;
      readonly name: string | null | undefined;
      readonly outstandingCents: number;
      readonly payoutAccountNumber: string | null | undefined;
      readonly principalCents: number;
      readonly proceedsRow: {
        readonly accountNumber: string | null | undefined;
        readonly amount: number;
        readonly description: string;
        readonly postingDate: string;
      } | null | undefined;
      readonly repaidCents: number;
      readonly repaymentCaseSensitive: boolean;
      readonly repaymentEndDate: any | null | undefined;
      readonly repaymentMatchField: string | null | undefined;
      readonly repaymentMatchKind: string | null | undefined;
      readonly repaymentMode: string;
      readonly repaymentPattern: string | null | undefined;
      readonly repaymentRows: ReadonlyArray<{
        readonly accountNumber: string | null | undefined;
        readonly amount: number;
        readonly classification: TxnClassificationEnum | null | undefined;
        readonly description: string;
        readonly md5: string;
        readonly postingDate: string;
      }>;
      readonly startDate: any;
      readonly termMonths: number | null | undefined;
      readonly totalOwedCents: number;
    }>;
  };
};
export type loansPage_Query = {
  response: loansPage_Query$data;
  variables: loansPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "perYear"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "perYear",
    "variableName": "perYear"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "handle",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "principalCents",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feeCents",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalOwedCents",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "holdbackBps",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "termMonths",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expectedMonthlySalesCents",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "payoutAccountNumber",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "repaymentMode",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "repaymentPattern",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "repaymentMatchKind",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "repaymentMatchField",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "repaymentCaseSensitive",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "repaymentEndDate",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "repaidCents",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "outstandingCents",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullyRepaid",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postingDate",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountNumber",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "md5",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "classification",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rank",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flagged",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "Loan",
  "kind": "LinkedField",
  "name": "loan",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "Txn",
  "kind": "LinkedField",
  "name": "txn",
  "plural": false,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "loansPage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Loans",
        "kind": "LinkedField",
        "name": "loans",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "debtByMonth",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Loan",
            "kind": "LinkedField",
            "name": "loans",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TransactionRow",
                "kind": "LinkedField",
                "name": "proceedsRow",
                "plural": false,
                "selections": [
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TransactionRow",
                "kind": "LinkedField",
                "name": "repaymentRows",
                "plural": true,
                "selections": [
                  (v29/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v30/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LoanCandidate",
            "kind": "LinkedField",
            "name": "candidates",
            "plural": true,
            "selections": [
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TransactionRow",
                "kind": "LinkedField",
                "name": "row",
                "plural": false,
                "selections": [
                  (v35/*: any*/),
                  (v29/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Stakeholder",
                    "kind": "LinkedField",
                    "name": "counterparty",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "loansPage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Loans",
        "kind": "LinkedField",
        "name": "loans",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "debtByMonth",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Loan",
            "kind": "LinkedField",
            "name": "loans",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TransactionRow",
                "kind": "LinkedField",
                "name": "proceedsRow",
                "plural": false,
                "selections": [
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TransactionRow",
                "kind": "LinkedField",
                "name": "repaymentRows",
                "plural": true,
                "selections": [
                  (v29/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v30/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LoanCandidate",
            "kind": "LinkedField",
            "name": "candidates",
            "plural": true,
            "selections": [
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TransactionRow",
                "kind": "LinkedField",
                "name": "row",
                "plural": false,
                "selections": [
                  (v35/*: any*/),
                  (v29/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Stakeholder",
                    "kind": "LinkedField",
                    "name": "counterparty",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "991fba1698a98d59f366b9bbfa0add4d",
    "id": null,
    "metadata": {},
    "name": "loansPage_Query",
    "operationKind": "query",
    "text": "query loansPage_Query(\n  $perYear: Int\n) {\n  loans(perYear: $perYear) {\n    debtByMonth {\n      month\n      value\n      id\n    }\n    loans {\n      id\n      handle\n      name\n      label\n      principalCents\n      feeCents\n      totalOwedCents\n      holdbackBps\n      startDate\n      termMonths\n      expectedMonthlySalesCents\n      payoutAccountNumber\n      repaymentMode\n      repaymentPattern\n      repaymentMatchKind\n      repaymentMatchField\n      repaymentCaseSensitive\n      repaymentEndDate\n      repaidCents\n      outstandingCents\n      fullyRepaid\n      proceedsRow {\n        postingDate\n        description\n        amount\n        accountNumber\n        id\n      }\n      repaymentRows {\n        md5\n        postingDate\n        description\n        amount\n        accountNumber\n        classification\n        id\n      }\n    }\n    candidates {\n      year\n      rank\n      flagged\n      loan {\n        id\n        label\n      }\n      row {\n        txn {\n          id\n        }\n        md5\n        postingDate\n        description\n        amount\n        accountNumber\n        counterparty {\n          name\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9dae61489f17a680bde567e14e57930b";

export default node;
